import { render, staticRenderFns } from "./TheInstructionsMenu.vue?vue&type=template&id=c0e1b234&scoped=true"
import script from "./TheInstructionsMenu.vue?vue&type=script&lang=js"
export * from "./TheInstructionsMenu.vue?vue&type=script&lang=js"
import style0 from "./TheInstructionsMenu.vue?vue&type=style&index=0&id=c0e1b234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e1b234",
  null
  
)

export default component.exports